
// import firebase from '../config/firebase';
// import firebase from "firebase/compat/app";

import { child, get, onValue, ref, set } from "firebase/database";
import { fireDatabase } from "../config/firebase";

export async function getAllusers(callback) {

    await onValue(ref(fireDatabase, 'users'), (snap)=>{
        const val = snap.val();
        // console.log('val: ', val);
        callback(val)
        return val;
    }, (errorObject) => {
        console.log('The read failed: ' + errorObject.name);
    });

}

export async function getAllProjects(callback) {

    await onValue(ref(fireDatabase, 'projects'), (data) => {
        const val = data.val();
        // console.log('val: ', val);
        callback(val);

    }, (errorObject) => {
        console.log('The read failed: ' + errorObject.name);
    });

}

export function getUser(userID, callback) {
    console.log('getUser');

    const dbRef = ref(fireDatabase);
    // Use child and get functions
    get(child(dbRef, `users/${userID}`)).then((snapshot) => {
    if (snapshot.exists()) {
        // console.log(snapshot.val());
        callback(snapshot.val())

    } else {
        console.log("No data available");
        callback(false)

    }
    }).catch((error) => {
        console.error(error);
        callback(false)

    });

    // dbRef.child("users").child(userID).get().then((snapshot) => {
    //     if (snapshot.exists()) {
    //         // console.log(snapshot.val());
    //         callback(snapshot.val())
    //     } else {
    //         console.log("No data available");
    //         callback(false)
    //     }
    // }).catch((error) => {
    //     console.error(error);
    //     callback(false)

    // });

}

export function getProject(id, callback, handleLoad, onError) {

    // console.log('getProject id: ', id);

    // fireDatabase.ref(`projects/${id}`).on('value', function (snap) {
    onValue(ref(fireDatabase, `projects/${id}`), (snap) => {
        const val = snap.val();
        // console.log('val: ', val);
        callback(val)
        if (handleLoad) {
            handleLoad(false);
        }
    }, (errorObject) => {
        console.log('The read failed: ' + errorObject.name);
        onError();
    });

}

export function saveProjectItems(projectID, items) {
    // console.log('save', items);
    // fireDatabase.ref(`projects/${projectID}/items`).set(items);
    set(ref(fireDatabase,`projects/${projectID}/items`), items);
}

export function saveProjectItem(projectID, itemID, data) {
    // fireDatabase.ref(`projects/${projectID}/items/${itemID}`).set(data);
    set(ref(fireDatabase,`projects/${projectID}/items/${itemID}`), data);

}

export function updateProjectItem(projectID, itemID, data) {
    // const dbRef = fireDatabase.ref();
    // dbRef.child('projects').child(projectID).child("items").child(itemID).set(data);
    set(ref(fireDatabase,`projects/${projectID}/items/${itemID}`), data);
    
}


